import axios from "@/plugins/axios";

let url = "/api/v1/me/orders";

export default {
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
    postConfirm(data) {
        return axios.post(`${url}/${data._id}/confirm`, data).then((result) => result.data);
    },
};
